const toggleMenu = () => {
	document.querySelector(".header__toggle-menu").addEventListener("click", () => {
		document.querySelector("body").classList.toggle("not-scroll");
		document.querySelector(".header__container").classList.toggle("open");
	});


	let itemsSubmenu = document.querySelectorAll(".header__menu-item.has-submenu .header__menu-level1");
	for (let itemSubmenu of itemsSubmenu) {
		itemSubmenu.addEventListener("click", (event) => {
			event.stopPropagation();
			itemSubmenu.parentNode.classList.toggle("open");

			let openItem = itemSubmenu.parentNode;
			let siblings = openItem.parentNode.childNodes;

			for (let i = 0; i < siblings.length; i++) {
				let sibling = siblings[i];
				if (sibling.nodeType === 1 && sibling !== openItem) {
					if (sibling.classList.contains("open")) {
						sibling.classList.remove('open');
					}
				}
			}

		});
	}

	let submenus = document.querySelectorAll(".header__menu-item.has-submenu .header__submenu");
	for (let submenu of submenus) {
		submenu.addEventListener("click", (event) => {
			event.stopPropagation();
		});
	}
	clickBody();

}

const clickBody = () => {
	document.querySelector("body").addEventListener("click", (event) => {
		if (window.innerWidth > 991) {
			let itemsMenu = document.querySelectorAll(".header__menu-item.has-submenu");
			for (let itemMenu of itemsMenu) {
				itemMenu.classList.remove("open");
			}
		} else {
			event.stopPropagation();
		}
	});
}


/* RESET MENU */
const resetMenu = () => {
	if (window.innerWidth > 991) {
		document.querySelector("body").classList.remove("not-scroll");
		document.querySelector(".header__container").classList.remove("open");
	}
	let itemsMenu = document.querySelectorAll(".header__menu-item.has-submenu");
	for (let itemMenu of itemsMenu) {
		itemMenu.classList.remove("open");
	}
}

/* STICKY HEADER */
const stickyHeader = () => {
	const header = document.querySelector(".cnf__header");
	let sticky = header.offsetTop;
	if (window.pageYOffset > sticky) {
		header.classList.add("cnf__sticky");
	} else {
		header.classList.remove("cnf__sticky");
	}
}




document.addEventListener('DOMContentLoaded', function () {
	toggleMenu();
	stickyHeader();
	resetMenu();
}, false);



window.onscroll = () => {
	stickyHeader()
};

window.onresize = () => {
	clickBody();
	resetMenu();
};

// Slider de ponentes en single-event solo en móvil
var init = false;
var singleEventSpeakersSwipper;
var cnfSwipperWrapper = document.getElementById("cnfSwipperWrapper");
if (null !== cnfSwipperWrapper) {
	function swiperSpeakers() {
		if (window.innerWidth <= 767) {
			if (!init) {
				init = true;
				cnfSwipperWrapper.classList.add("swiper-wrapper");
				singleEventSpeakersSwipper = new Swiper(".single-event-speakers-slide", {
					slidesPerView: "auto",
					loop: false,
					pagination: {
						el: ".swiper-pagination-single-event-speakers",
						clickable: true
					}
				})

			}
		} else if (init) {
			singleEventSpeakersSwipper.destroy();
			cnfSwipperWrapper.classList.remove("swiper-wrapper");
			init = false;
		}
	}
	swiperSpeakers();
	window.addEventListener("resize", swiperSpeakers);
}


// Al cargar la página se elimina la clase swiper-wrapper si estamos en desktop
if (null !== cnfSwipperWrapper) {
	document.addEventListener("DOMContentLoaded", function () {
		if (window.innerWidth > 767 && cnfSwipperWrapper.classList.contains("swiper-wrapper")) {
			cnfSwipperWrapper.classList.remove("swiper-wrapper");
		}
	});
}
